import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/hero-image.jpeg'
    },
    {
      image: '/gallery1.jpeg'
    },
    {
      image: '/gallery3.jpeg'
    },
    {
      image: '/gallery4.jpeg'
    },
    {
      image: '/gallery5.jpeg'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  // Auto-advancing carousel; manual controls removed as unused
  return (
    <section className="relative w-full h-[649px] max-md:h-[420px] max-sm:h-[280px] flex items-center overflow-hidden mt-[70px] mx-auto">
      {/* Carousel Images */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 z-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img 
            src={slide.image} 
            alt={`Slide ${index + 1}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}


    </section>
  );
};

export default HeroSection;